import React, {Component, PropTypes} from 'react'
import {Row, Col, Card, Button} from 'react-materialize';

import html2canvas from "html2canvas";
import jsPDF from "jspdf";

import equipment from '../../images/equipment.png';

import {CSVLink} from "react-csv";

import {FormattedMessage, FormattedHTMLMessage} from 'react-intl';
import {injectIntl, intlShape} from 'react-intl';
import DatePicker from "react-datepicker";

class ChecklistProtecao extends Component{

    constructor(props){
        super(props);

        this.handleDownloadPDF= this.handleDownloadPDF.bind(this);

        this.showDiv6= this.showDiv6.bind(this);
        this.showDiv7= this.showDiv7.bind(this);
        this.showDiv8= this.showDiv8.bind(this);
        this.showDiv9= this.showDiv9.bind(this);
        this.showDiv10= this.showDiv10.bind(this);
        this.showDiv11= this.showDiv11.bind(this);

        this.state ={
        showComponent6: false, /*equipamentos de protecao*/
            showComponent7: false,
            showComponent8: false,
            showComponent9: false,
            showComponent10: false,
            showComponent11: false,

            data: [
                { pergunta: "Os equipamentos de proteção individual (EPI) são fornecidos sem custo aos trabalhadores e colaboradores?", resposta: "Sim ou não"},
                { pergunta: "Os equipamentos de proteção coletiva (EPC) estão disponíveis e visíveis aos trabalhadores?", resposta: "Sim ou não"},
                { pergunta: "Os profissionais são treinados no uso e manutenção dos equipamentos individuais e coletivos?", resposta: "Sim ou não"},
                { pergunta: "Os trabalhadores utilizam roupas adequadas para proteger-se de temperaturas extremas?"
                    , resposta: "Sim ou não" },
                { pergunta: "Equipamentos de proteção são utilizados pelos trabalhadores ao manusear produtos químicos?", resposta: "Sim ou não"},
                { pergunta: "Os trabalhadores usam roupas ajustadas ao corpo e cabelos presos ao trabalhar perto de máquinas?", resposta: "Sim ou não"},

            ],
    }}

    handleDownloadPDF = () => {

        window.scrollTo(0,0);

        html2canvas(document.querySelector('#printDiv'), {  allowTaint: true,
            useCORS: true,
            logging: false,
            height: window.outerHeight + window.innerHeight,
            windowHeight: window.outerHeight + window.innerHeight, }).then( function (canvas){


            const imgData = canvas.toDataURL("image/png", 1.0);


            const pdf = new jsPDF("p", "mm", "a4");

            pdf.addImage(imgData, 'PNG', 0,0);
            pdf.save("Checklist.pdf");
        })
    };

    /***protection***/

    showDiv6 = (e) => {
        this.setState({
            showComponent6: e.target.checked,
        });
    };

    showDiv7 = (e) => {
        this.setState({
            showComponent7: e.target.checked,
        });
    };

    showDiv8 = (e) => {
        this.setState({
            showComponent8: e.target.checked,
        });
    };

    showDiv9 = (e) => {
        this.setState({
            showComponent9: e.target.checked,
        });
    };

    showDiv10 = (e) => {
        this.setState({
            showComponent10: e.target.checked,
        });
    };

    showDiv11 = (e) => {
        this.setState({
            showComponent11: e.target.checked,
        });
    };

    handleChangeDatePicker = date => {
        this.setState({
            startDate: date
        });
    };

    render(){

        const intl= this.props.intl;

        const placeholder = intl.formatMessage({id: 'ph.checklist1', defaultMessage: 'Nome do responsável'});
        const placeholder2 = intl.formatMessage({id: 'ph.checklist2', defaultMessage: 'Data de inspeção:'});
        const placeholder3 = intl.formatMessage({id: 'ph.checklist3', defaultMessage: 'Insira ação corretiva'});

        return(
            <Card>

                <Row>
                    <div className={"text-center"} align="center">
                        <img src={equipment} className={"img"} alt={"Aquasafe logo"} width={"100"} height={"100"}/>
                    </div>
                </Row>

                <div id={"printDiv"}>
                    <div align={"center"}>
                    <h5><b><FormattedMessage id={"prot.ch"} defaultMessage={"Checklist Equipamentos de Proteção"}/></b></h5>
                    </div>
                    <input type={"text"} placeholder={placeholder} key={"nome"} />

                <React.Fragment>{

                    intl.locale==="en" ?

                        <DatePicker placeholderText={placeholder2} key={"data"}   selected={this.state.startDate}

                                    onChange={this. handleChangeDatePicker}/> :

                        <DatePicker locale={"pt"}  dateFormat="dd/MM/yyyy" placeholderText={placeholder2} key={"data"}   selected={this.state.startDate}

                                    onChange={this. handleChangeDatePicker}/>
                }</React.Fragment>


                    <div className={"margin"}>
                        <b><FormattedMessage id={"prot.ch"} defaultMessage={"Checklist Equipamentos de Proteção"}/></b></div>

                    <div className={"protection1"}>

                        <form action={"#"} className={"formsWorks"}>

                            <p><FormattedMessage id={"prot.ch1"} defaultMessage={"Os equipamentos de proteção individual (EPI) são fornecidos sem custo aos trabalhadores e colaboradores?"}/>
                            </p>

                            <input type={"checkbox"} id={"yes6"}/>

                            <label htmlFor={"yes6"} ><FormattedMessage id={"yes"} defaultMessage={"Sim"}/></label>

                            <div>
                                <input type={"checkbox"} id={"no6"} onClick={this.showDiv6}/>

                                <label htmlFor={"no6"}><FormattedMessage id={"no"} defaultMessage={"Não"}/></label>
                            </div>
                            {this.state.showComponent6 ?
                                <div className={"hidden-input"}> <input type={"text"} placeholder={placeholder3}/> </div>: null }


                        </form>
                    </div>

                    <div className={"protection2"}>
                        <form action={"#"}>

                            <p><FormattedMessage id={"prot.ch2"} defaultMessage={"Os equipamentos de proteção coletiva (EPC) estão disponíveis e visíveis aos trabalhadores?"}/></p>

                            <input type={"checkbox"} id={"yes7"}/>

                            <label htmlFor={"yes7"}><FormattedMessage id={"yes"} defaultMessage={"Sim"}/></label>

                            <div>
                                <input type={"checkbox"} id={"no7"} onClick={this.showDiv7}/>

                                <label htmlFor={"no7"}><FormattedMessage id={"no"} defaultMessage={"Não"}/></label>
                            </div>
                            {this.state.showComponent7 ?
                                <div className={"hidden-input"}> <input type={"text"} placeholder={placeholder3}/> </div>: null }
                        </form>
                    </div>

                    <div className={"#protection3"}>
                        <form action={"#"}>

                            <p><FormattedMessage id={"prot.ch3"} defaultMessage={"Os profissionais são treinados no uso e manutenção dos equipamentos individuais e coletivos?"}/>
                            </p>

                            <input type={"checkbox"} id={"yes8"}/>

                            <label htmlFor={"yes8"}><FormattedMessage id={"yes"} defaultMessage={"Sim"}/></label>

                            <div>
                                <input type={"checkbox"} id={"no8"} onClick={this.showDiv8}/>

                                <label htmlFor={"no8"}><FormattedMessage id={"no"} defaultMessage={"Não"}/></label>
                            </div>
                            {this.state.showComponent8 ?
                                <div className={"hidden-input"}> <input type={"text"} placeholder={placeholder3}/> </div>: null }
                        </form>
                    </div>

                    <div className={"#protection4"}>
                        <form action={"#"}>

                            <p><FormattedMessage id={"prot.ch4"} defaultMessage={"Os trabalhadores utilizam roupas adequadas para proteger-se de temperaturas extremas?"}/></p>

                            <input type={"checkbox"} id={"yes9"}/>

                            <label htmlFor={"yes9"}><FormattedMessage id={"yes"} defaultMessage={"Sim"}/></label>

                            <div>
                                <input type={"checkbox"} id={"no9"} onClick={this.showDiv9}/>

                                <label htmlFor={"no9"}><FormattedMessage id={"no"} defaultMessage={"Não"}/></label>
                            </div>
                            {this.state.showComponent9 ?
                                <div className={"hidden-input"}> <input type={"text"} placeholder={placeholder3}/> </div>: null }
                        </form>
                    </div>

                    <div className={"protection5"}>
                        <form action={"#"}>

                            <p><FormattedMessage id={"prot.ch5"} defaultMessage={"Equipamentos de proteção são utilizados pelos trabalhadores ao manusear produtos químicos?"}/></p>

                            <input type={"checkbox"} id={"yes10"}/>

                            <label htmlFor={"yes10"}><FormattedMessage id={"yes"} defaultMessage={"Sim"}/></label>

                            <div>
                                <input type={"checkbox"} id={"no10"} onClick={this.showDiv10}/>

                                <label htmlFor={"no10"}><FormattedMessage id={"no"} defaultMessage={"Não"}/></label>
                            </div>
                            {this.state.showComponent10 ?
                                <div className={"hidden-input"}> <input type={"text"} placeholder={placeholder3}/> </div>: null }

                        </form>
                    </div>

                    <div className={"protection6"}>

                        <form action={"#"} className={"formsWorks"}>

                            <p><FormattedMessage id={"prot.ch6"} defaultMessage={"Os trabalhadores usam roupas ajustadas ao corpo e cabelos presos ao trabalhar perto de máquinas?"}/>
                            </p>

                            <input type={"checkbox"} id={"yes11"}/>

                            <label htmlFor={"yes11"} ><FormattedMessage id={"yes"} defaultMessage={"Sim"}/></label>

                            <div>
                                <input type={"checkbox"} id={"no11"} onClick={this.showDiv11}/>

                                <label htmlFor={"no11"}><FormattedMessage id={"no"} defaultMessage={"Não"}/></label>
                            </div>
                            {this.state.showComponent11 ?
                                <div className={"hidden-input"}> <input type={"text"} placeholder={placeholder3}/> </div>: null }


                        </form>
                    </div>
                </div>

                <br/>

                <Button className={"button"} onClick={this.handleDownloadPDF} >
                  PDF
                </Button>


                <CSVLink data={this.state.data} separator={";"} filename={"checklist.csv"}>
                    <Button className={"button"}>
                        CSV
                    </Button> </CSVLink>

            </Card>
        )}

}

export default injectIntl(ChecklistProtecao);